import { EventEmitter } from '@angular/core';
import { Utils } from './utils.core';
import { Transfer } from './transfer.core';
import { FileManager } from './fileManager.core';
import { FileSizePipe } from '../pipe/fileSizePipe.pipe';

// tslint:disable:max-line-length

let {
    FormData
} = ( /** @type {?} */((<any>window)));
/**
 * Absractr proctol class if someone want to write his own protocol
 * 
 * @export
 * @abstract
 * \@class Protocol
 * @abstract
 */
export abstract class Protocol {
    _progress: EventEmitter<any>;
    _load: EventEmitter<any>;
    _error: EventEmitter<any>;
    _abort: EventEmitter<any>;
/**
 * @param {?} obj
 * @return {?}
 */
public set connection(obj: any) {
        let {
            _file,
            _connection
        } = obj;
        if (!this.isConnected(_file)) {
            this._connections.push({
                id: _file.id,
                connection: _connection
            });
        }
    }
private _id: string;
private _connections: any[];
/**
 * Creates an instance of Protocol and for each protocol an own unique ID.
 * 
 * 
 * \@memberOf Protocol
 */
constructor () {
        this._id = Utils.uniqueID();
        this._progress = new EventEmitter<any>();
        this._load = new EventEmitter<any>();
        this._error = new EventEmitter<any>();
        this._abort = new EventEmitter<any>();
        this._connections = [];
    }
/**
 * Call uploader method _onCompleteFile.
 * 
 * 
 * \@memberOf Protocol
 * @param {?} _file
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
public _onLoad (_file: FileManager, response: any, status: number, headers: any): void {
        let /** @type {?} */ uploader: Transfer = _file.getUploader();
        let /** @type {?} */ gist = this._isSuccessCode(status);
        let /** @type {?} */ method = (g: boolean, f: FileManager, r: any, s: number, h: any) => { if (g) { uploader._onSuccessFile(f, r, s, h); } else { uploader._onErrorFile(f, r, s, h); } };
        method(gist, _file, response, status, headers);
        uploader._onCompleteFile(_file, response, status, headers);
    }
/**
 * Call uploader methodes _onErrorFile and _onCompleteFile.
 * 
 * 
 * \@memberOf Protocol
 * @param {?} _file
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
public _onError (_file: FileManager, response: any, status: number, headers: any): void {
        let /** @type {?} */ uploader: Transfer = _file.getUploader();
        uploader._onErrorFile(_file, response, status, headers);
        uploader._onCompleteFile(_file, response, status, headers);
    }
/**
 * Call uploader methodes _onErrorFile and _onCompleteFile.
 * 
 * 
 * \@memberOf Protocol
 * @param {?} _file
 * @param {?} response
 * @param {?} status
 * @param {?} headers
 * @return {?}
 */
public _onAbort (_file: FileManager, response: any, status: number, headers: any): void {
        let /** @type {?} */ uploader: Transfer = _file.getUploader();
        uploader._onErrorFile(_file, response, status, headers);
        uploader._onCompleteFile(_file, response, status, headers);
    }
/**
 * Validate response status code.
 * 
 * 
 * \@memberOf Protocol
 * @param {?} status
 * @return {?}
 */
public _isSuccessCode(status: number): boolean {
         return (status >= 200 && status < 300) || status === 304;
    }
/**
 * @param {?} _file
 * @return {?}
 */
public isConnected(_file: FileManager): any {
        for (let /** @type {?} */ _request of this._connections) {
            if (_request.id === _file.id) {
                return _request;
            }
        }
        return false;
    }
/**
 * @param {?} _file
 * @return {?}
 */
public removeConnection(_file: FileManager): void {
        let /** @type {?} */ _request: any | null = null;
        for (let /** @type {?} */ _key in this._connections) {
            if ( this._connections.hasOwnProperty( _key ) ) {
                _request = this._connections[_key];
                if (_file.id === _request.id) {
                    this._connections.splice(+_key, 1);
                }
            }
        }
    }
/**
 * Must be implemented at each protocol class.
 * 
 * @abstract 
 * 
 * \@memberOf Protocol
 * @abstract
 * @param {?} _file
 * @return {?}
 */
run(_file: FileManager) {}
/**
 * @abstract
 * @param {?} _file
 * @return {?}
 */
cancel(_file: FileManager) {}
}

function Protocol_tsickle_Closure_declarations() {
/** @type {?} */
Protocol.prototype._progress;
/** @type {?} */
Protocol.prototype._load;
/** @type {?} */
Protocol.prototype._error;
/** @type {?} */
Protocol.prototype._abort;
/** @type {?} */
Protocol.prototype._id;
/** @type {?} */
Protocol.prototype._connections;
}

/**
 * Standard protocol for server communication (file uploading)
 * 
 * @export
 * \@class ProtocolXHR
 */
export class ProtocolXHR extends Protocol {
constructor () {
        super();
    }
/**
 * Implementation of the abstract.protocol method `run`
 * 
 * 
 * \@memberOf ProtocolXHR
 * @param {?} _file
 * @return {?}
 */
public run (_file: FileManager): void {
        let /** @type {?} */ _xhr: XMLHttpRequest;
        let /** @type {?} */ sendable: any;
        let /** @type {?} */ uploader: Transfer = _file.getUploader();

        let /** @type {?} */ _formData = Utils.extendValue(uploader.options.formData, _file.options.formData);
        let /** @type {?} */ _withCredentials = Utils.extendValue(uploader.options.withCredentials, _file.options.withCredentials);
        let /** @type {?} */ _method = Utils.extendValue(uploader.options.method, _file.options.method);
        let /** @type {?} */ _url = Utils.extendValue(uploader.options.url, _file.options.url);
        let /** @type {?} */ _alias = Utils.extendValue(uploader.options.alias, _file.options.alias);
        let /** @type {?} */ _headers = Utils.extendValue(uploader.options.headers, _file.options.headers);

        let /** @type {?} */ time: number = new Date().getTime();
        let /** @type {?} */ load = 0;
        let /** @type {?} */ speed = 0;
        let /** @type {?} */ sppedToText: string|null = null;
        let /** @type {?} */ $filesize = new FileSizePipe();

        _xhr = new XMLHttpRequest();

        this.connection = {
            _file: _file,
            _connection: _xhr
        };

        sendable = new FormData();

        if (typeof _formData !== 'undefined') {
            // Only allow Multipart
            for (let /** @type {?} */ obj of _formData) {
                for (let /** @type {?} */ key in obj) {
                    if ( obj.hasOwnProperty( key ) ) {
                        let /** @type {?} */ value = obj[key];
                        sendable.append(key, value);
                    }
                }
            }
        }

        sendable.append(_alias, _file.element, _file.name);

        if (typeof(_file.size) !== 'number') {
            throw new TypeError('We need the file size.');
        }

        _xhr.upload.addEventListener('progress', (event: ProgressEvent) => {
            if (event.lengthComputable) {
                let /** @type {?} */ _time = new Date().getTime() - time;
                load = event.loaded - load;
                speed = load / _time * 1000;
                speed = parseInt( /** @type {?} */((<any>speed)), 10);
                sppedToText = $filesize.transform(speed);
                let /** @type {?} */ _obj = {
                    total: event.total,
                    loaded: event.loaded,
                    percent: Math.round(event.loaded / event.total * 100),
                    speed: speed,
                    speedToText: sppedToText
                };
                this._progress.emit({_file: _file, _data: _obj});
            }
        });
        _xhr.addEventListener('load', () => {
            let /** @type {?} */ headers = uploader._parseHeaders(_xhr.getAllResponseHeaders());
            let /** @type {?} */ response = uploader._transformResponse(_xhr.response, headers);
            let /** @type {?} */ status = _xhr.status;
            this._load.emit({_file: _file, response: response, status: status, headers: headers});
        });
        _xhr.addEventListener('error', () => {
            let /** @type {?} */ headers = uploader._parseHeaders(_xhr.getAllResponseHeaders());
            let /** @type {?} */ response = uploader._transformResponse(_xhr.response, headers);
            let /** @type {?} */ status = _xhr.status;
            this._error.emit({_file: _file, response: response, status: status, headers: headers});
        });
        _xhr.addEventListener('abort', () => {
            let /** @type {?} */ headers = uploader._parseHeaders(_xhr.getAllResponseHeaders());
            let /** @type {?} */ response = uploader._transformResponse(_xhr.response, headers);
            let /** @type {?} */ status = _xhr.status;
            this._abort.emit({_file: _file, response: response, status: status, headers: headers});
        });

        _xhr.open(_method, _url, true);

        _xhr.withCredentials = _withCredentials;

        for (let /** @type {?} */ name in _headers) {
            if ( _headers.hasOwnProperty( name ) ) {
                let /** @type {?} */ value = _headers[name];
                _xhr.setRequestHeader(name, value);
            }
        }

        _xhr.send(sendable);
    }
/**
 * @param {?} _file
 * @return {?}
 */
public cancel(_file: FileManager) {
        let /** @type {?} */ _request = this.isConnected(_file);
        if (!!_request) {
            _request.connection.abort();
            this.removeConnection(_file);
        }
    }
}
